var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoSceneThumbDefualt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 140,
    viewBox: "0 0 251 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251 0H0V140H251V0Z",
    fill: "#E7EEF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219 45H32V54H219V45Z",
    fill: "#B8D5EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203 29H48V38H203V29Z",
    fill: "#B8D5EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191 62H61V71H191V62Z",
    fill: "#B8D5EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116 90H56C54.3431 90 53 91.3431 53 93V106C53 107.657 54.3431 109 56 109H116C117.657 109 119 107.657 119 106V93C119 91.3431 117.657 90 116 90Z",
    fill: "#5FACF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196 90H136C134.343 90 133 91.3431 133 93V106C133 107.657 134.343 109 136 109H196C197.657 109 199 107.657 199 106V93C199 91.3431 197.657 90 196 90Z",
    fill: "#5FACF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.696,
    d: "M126 29C137.598 29 147 38.402 147 50C147 61.598 137.598 71 126 71C114.402 71 105 61.598 105 50C105 38.402 114.402 29 126 29Z",
    fill: "#0085FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.133 60.5667L135.316 50.3102L121.133 40.3462L121.133 60.5667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSceneThumbDefualt);
export default __webpack_public_path__ + "static/media/VideoSceneThumbDefualt.07c0aa6660918424e3d18b66dfc70a4a.svg";
export { ForwardRef as ReactComponent };